<!-- Rail -->
<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (
      rail.searchQuery.journeyType === 'SingleJourney' ||
      rail.searchQuery.journeyType === 'OpenReturnJourney'
    ) {
      @if (rail?.detail; as detail) {
        <div [class.duplicate-item-wrapper]="duplicateBooking">
          @if (duplicateBooking) {
            <div class="duplicate-item-date">
              <i class="ico-rail"></i>&nbsp;
              @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                <strong>{{ departureDateTime | sabsDate: 1 }}</strong>
                @if (!detail.isEU) {
                  <strong>
                    {{ departureDateTime | date: 'HH:mm' }}
                  </strong>
                }
                @if (detail.isEU) {
                  <strong>
                    {{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}
                  </strong>
                }
              }
            </div>
          }
          <div [class.duplicate-item-info]="duplicateBooking">
            <div class="cart_item_heading">
              @if (!duplicateBooking) {
                <i class="ico-rail"></i>&nbsp;
              }
              <strong
                >{{ detail.outwardDetail.departureStationName }} <span i18n="@@to">to</span>
                {{ detail.outwardDetail.arrivalStationName }}</strong
              >
              @if (!duplicateBooking) {
                <button
                  class="cart_item_remove ico-trash"
                  i18n-title
                  attr.title="Remove {{ detail.outwardDetail.departureStationName }} to {{
                    detail.outwardDetail.arrivalStationName
                  }} from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                  attr.aria-label="Remove {{ detail.outwardDetail.departureStationName }} to {{
                    detail.outwardDetail.arrivalStationName
                  }} rail from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                  (click)="remove.emit()"
                  i18n-aria-label
                  id="share-basketitem-{{ rail.id }}-0"
                ></button>
              }
              @if (!duplicateBooking) {
                <section (mouseleave)="tt1.close()">
                  <img
                    src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                      displayItinerary ? 'luggage_icon' : 'basket_move'
                    }}.svg"
                    class="move_basket_icon"
                    ngbTooltip="Move to different {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    i18n-ngbTooltip
                    role="button"
                    attr.aria-label="Move {{ detail.outwardDetail.departureStationName }} to {{
                      detail.outwardDetail.arrivalStationName
                    }} rail to different {{
                      (displayItinerary ? 'itinerary' : 'basket') | translate
                    }}"
                    i18n-aria-label
                    (click)="openChangeModal.emit()"
                    (keydown.enter)="openChangeModal.emit()"
                    (keydown.space)="openChangeModal.emit()"
                    triggers="manual"
                    #tt1="ngbTooltip"
                    (mouseenter)="tt1.open()"
                    (focus)="tt1.open()"
                    (blur)="tt1.close()"
                    tabindex="0"
                    id="share-basketitem-{{ rail.id }}-0"
                  />
                </section>
              }
            </div>
            @if (
              !duplicateBooking && detail?.outwardDetail?.departureDateTime;
              as departureDateTime
            ) {
              <div class="cart_item_rail_ticket_times">
                <span i18n="@@itineraryDepart">Depart:</span>
                <span
                  >{{ departureDateTime | sabsDate: 1 }}
                  @if (!detail.isEU) {
                    {{ departureDateTime | sabsTimePipe: 'timeString' }}
                  }
                  @if (detail.isEU) {
                    {{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}
                  }
                </span>
                <br />
                @if (detail?.outwardDetail?.arrivalDateTime; as arrivalDateTime) {
                  <span i18n="@@itineraryArrive">Arrives:</span>
                  <span
                    >{{ arrivalDateTime | sabsDate: 1 }}
                    @if (!detail.isEU) {
                      {{ arrivalDateTime | sabsTimePipe: 'timeString' }}
                    }
                    @if (detail.isEU) {
                      {{ arrivalDateTime | sabsTimePipe: 'trainline_eu_time' }}
                    }
                  </span>
                }
              </div>
            }
            @if (detail?.outwardDetail?.supplierTickets[0]; as supplierTicket) {
              @if (supplierTicket?.legs; as legs) {
                <div class="cart_item_operator">
                  <span i18n="@@flightBasketOperatedBy">Operated by:</span>
                  <span>{{ getRailOperators(legs) }}</span>
                </div>
              }
              @if (supplierTicket?.ticketDescription; as ticketDescription) {
                <div class="cart_item_rail_ticket_name">
                  <span i18n="@@basketPanelTicketRail">Ticket:</span>
                  @if (detail?.outbound?.isSplit) {
                    <app-split-ticket-icon></app-split-ticket-icon>
                  } @else {
                    <span
                      [ngClass]="detail?.outbound?.isSplit ? 'ticket-name-split' : 'ticket-name'"
                      >{{ ticketDescription }}</span
                    >
                  }

                  @if (!duplicateBooking) {
                    <a
                      tabindex="0"
                      (click)="
                        openTicketCondition(
                          detail?.outbound,
                          detail?.termsAndCond?.outboundTerms,
                          detail.outwardDetail.departureStationName,
                          detail.outwardDetail.arrivalStationName
                        )
                      "
                      (keydown.enter)="
                        openTicketCondition(
                          detail?.outbound,
                          detail?.termsAndCond?.outboundTerms,
                          detail.outwardDetail.departureStationName,
                          detail.outwardDetail.arrivalStationName
                        );
                        $event.stopPropagation()
                      "
                      role="button"
                      class="fare_rules_link"
                      attr.aria-label="Ticket conditions for {{
                        detail.outwardDetail.departureStationName
                      }} to {{ detail.outwardDetail.arrivalStationName }}"
                      ngbTooltip="Ticket conditions"
                      i18n-ngbTooltip
                      triggers="manual"
                      #ttOutwardTicket="ngbTooltip"
                      (mouseenter)="ttOutwardTicket.open()"
                      (focus)="ttOutwardTicket.open()"
                      (blur)="ttOutwardTicket.close()"
                      (mouseleave)="ttOutwardTicket.close()"
                      ><i class="currency_info_icon"></i
                      ><span class="visuallyhidden" i18n="@@railBasketTicketConditions"
                        >Ticket conditions</span
                      ></a
                    >
                  }
                </div>
              }
              @if (detail?.outbound?.isSplit && detail?.outbound?.fares?.length) {
                <app-split-ticket-panel
                  [isSplit]="detail?.outbound?.isSplit"
                  [fares]="detail?.outbound?.fares"
                >
                </app-split-ticket-panel>
              }
              @if (outwardPermittedOrigins?.length || outwardPermittedDestinations?.length) {
                <div class="cart_item_rail_permitted_stations">
                  <span>
                    Travel also permitted
                    {{ outwardPermittedOrigins?.length ? 'from' : 'to' }} stations near
                    {{
                      outwardPermittedOrigins?.length
                        ? detail.outwardDetail.departureStationName
                        : detail.outwardDetail.arrivalStationName
                    }}{{
                      outwardPermittedDestinations?.length && outwardPermittedOrigins?.length
                        ? ' and to stations near ' + detail.outwardDetail.arrivalStationName
                        : ''
                    }}.
                    <section class="container" (mouseleave)="tt4.close()">
                      <u
                        [ngbTooltip]="outwardPermittedStations"
                        #tt4="ngbTooltip"
                        triggers="manual"
                        (mouseenter)="tt4.open()"
                        (focus)="tt4.open()"
                        (blur)="tt4.close()"
                        tabindex="0"
                        i18n="@@ViewStations"
                        >View stations</u
                      >
                    </section></span
                  >
                </div>
              }
              @if (openReturnValidity) {
                <div>
                  <span>{{ openReturnValidity }}</span>
                </div>
              }
              @if (detail.outbound?.ticketExtras; as ticketExtras) {
                <div>
                  <div class="cart_item_rail_ticket_name">
                    <span>Travelcard {{ ticketExtras[0].location | translate }}</span>
                  </div>
                </div>
              }
              @if (detail?.outbound?.noFirstClassSeats) {
                <div class="first-class-warning" id="outbound_first_class_warning">
                  <i
                    class="ico ico-exclamation-filled first-class-warning-icon"
                    aria-hidden="true"
                  ></i>
                  <span i18n="@@railNoFirstClassAllLegs"
                    >First Class accommodation is not available on all legs of this journey.</span
                  >
                </div>
              }
            }
          </div>
          @if (!duplicateBooking) {
            <div class="car_cart_item_to_point"></div>
          }
          @if (duplicateBooking) {
            <div class="cart_item_price">
              <strong i18n="@@basketPanelCostRail">Cost</strong>
              <strong>{{ rail.price | currency: rail.currency }}</strong>
            </div>
          }
        </div>
      }
    }

    @if (rail.searchQuery.journeyType === 'ReturnJourney') {
      @if (rail?.detail; as detail) {
        <div>
          <div [class.duplicate-item-wrapper]="duplicateBooking">
            @if (duplicateBooking && detail.outwardDetail) {
              <div class="duplicate-item-date">
                <i class="ico-rail"></i>&nbsp;
                @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                  <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                  <strong
                    >{{ departureDateTime | sabsDate: 1 }}
                    @if (!detail.isEU) {
                      <span>{{ departureDateTime | sabsTimePipe: 'timeString' }}</span>
                    }
                    @if (detail.isEU) {
                      <span>{{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}</span>
                    }
                  </strong>
                }
              </div>
            }
            <div [class.duplicate-item-info]="duplicateBooking">
              @if (detail.outwardDetail; as outwardDetail) {
                <div class="cart_item_heading">
                  @if (!duplicateBooking) {
                    <i class="ico-rail"></i>&nbsp;
                  }
                  <strong
                    >{{ outwardDetail.departureStationName }} to
                    {{ outwardDetail.arrivalStationName }}</strong
                  >
                  @if (!duplicateBooking) {
                    <section (mouseleave)="tt2.close()">
                      <button
                        class="cart_item_remove ico-trash"
                        ngbTooltip="Remove {{ outwardDetail.departureStationName }} to {{
                          outwardDetail.arrivalStationName
                        }} from your {{ (displayItinerary ? 'itinerary' : 'basket') | translate }}"
                        attr.aria-label="Remove {{ outwardDetail.departureStationName }} to {{
                          outwardDetail.arrivalStationName
                        }} rail from your {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        i18n-ngbTooltip
                        (click)="remove.emit()"
                        triggers="manual"
                        #tt2="ngbTooltip"
                        (mouseenter)="tt2.open()"
                        (focus)="tt2.open()"
                        (blur)="tt2.close()"
                        id="remove-basketitem-{{ rail.id }}-1"
                      ></button>
                    </section>
                  }
                  @if (!duplicateBooking) {
                    <section (mouseleave)="tt3.close()">
                      <img
                        src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                          displayItinerary ? 'luggage_icon' : 'basket_move'
                        }}.svg"
                        class="move_basket_icon"
                        role="button"
                        i18n-ngbTooltip
                        attr.aria-label="Move {{ outwardDetail.departureStationName }} to {{
                          outwardDetail.arrivalStationName
                        }} rail to different {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        ngbTooltip="Move item to different {{
                          (displayItinerary ? 'itinerary' : 'basket') | translate
                        }}"
                        (click)="openChangeModal.emit()"
                        (keydown.enter)="openChangeModal.emit()"
                        (keydown.space)="openChangeModal.emit()"
                        triggers="manual"
                        #tt3="ngbTooltip"
                        (mouseenter)="tt3.open()"
                        (focus)="tt3.open()"
                        (blur)="tt3.close()"
                        tabindex="0"
                        id="share-basketitem-{{ rail.id }}-1"
                      />
                    </section>
                  }
                </div>
              }
              @if (detail?.outwardDetail?.departureDateTime; as departureDateTime) {
                <div class="cart_item_rail_ticket_times">
                  @if (!duplicateBooking) {
                    <span i18n="@@itineraryDepart">Depart:</span>
                    <span
                      >{{ departureDateTime | sabsDate: 1 }}
                      @if (!detail.isEU) {
                        {{ departureDateTime | sabsTimePipe: 'timeString' }}
                      }
                      @if (detail.isEU) {
                        {{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}
                      }
                    </span>
                    <br />
                    @if (detail?.outwardDetail?.arrivalDateTime; as arrivalDateTime) {
                      <span i18n="@@itineraryArrive">Arrives:</span>
                      <span
                        >{{ arrivalDateTime | sabsDate: 1 }}
                        @if (!detail.isEU) {
                          {{ arrivalDateTime | sabsTimePipe: 'timeString' }}
                        }
                        @if (detail.isEU) {
                          {{ arrivalDateTime | sabsTimePipe: 'trainline_eu_time' }}
                        }
                      </span>
                    }
                  }
                </div>
              }
              @if (detail?.outwardDetail?.supplierTickets[0]; as supplierTicket) {
                @if (supplierTicket?.legs; as legs) {
                  <div class="cart_item_operator">
                    <span i18n="@@flightBasketOperatedBy">Operated by:</span>
                    <span>{{ getRailOperators(legs) }}</span>
                  </div>
                }
                @if (supplierTicket?.ticketDescription; as ticketDescription) {
                  <div class="cart_item_rail_ticket_name">
                    <span i18n="@@basketPanelTicketRail">Ticket:</span>
                    @if (detail?.outbound?.isSplit) {
                      <app-split-ticket-icon></app-split-ticket-icon>
                    } @else {
                      <span
                        [ngClass]="detail?.outbound?.isSplit ? 'ticket-name-split' : 'ticket-name'"
                        >{{ ticketDescription }}</span
                      >
                    }

                    @if (!duplicateBooking) {
                      <a
                        tabindex="0"
                        (click)="
                          openTicketCondition(
                            detail?.outbound,
                            detail?.termsAndCond?.outboundTerms,
                            detail.outwardDetail.departureStationName,
                            detail.outwardDetail.arrivalStationName
                          )
                        "
                        (keydown.enter)="
                          openTicketCondition(
                            detail?.outbound,
                            detail?.termsAndCond?.outboundTerms,
                            detail.outwardDetail.departureStationName,
                            detail.outwardDetail.arrivalStationName
                          );
                          $event.stopPropagation()
                        "
                        role="button"
                        class="fare_rules_link"
                        attr.aria-label="Ticket conditions for {{
                          detail.outwardDetail.departureStationName
                        }} to {{ detail.outwardDetail.arrivalStationName }}"
                        ngbTooltip="Ticket conditions"
                        i18n-ngbTooltip
                        triggers="manual"
                        #ttOutwardTicket2="ngbTooltip"
                        (mouseenter)="ttOutwardTicket2.open()"
                        (focus)="ttOutwardTicket2.open()"
                        (blur)="ttOutwardTicket2.close()"
                        (mouseleave)="ttOutwardTicket2.close()"
                        ><i class="currency_info_icon"></i
                        ><span class="visuallyhidden" i18n="@@railBasketTicketConditions"
                          >Ticket conditions</span
                        ></a
                      >
                    }
                  </div>
                }
                @if (detail?.outbound?.isSplit && detail?.outbound?.fares?.length) {
                  <app-split-ticket-panel
                    [isSplit]="detail?.outbound?.isSplit"
                    [fares]="detail?.outbound?.fares"
                  >
                  </app-split-ticket-panel>
                }
                @if (outwardPermittedOrigins?.length || outwardPermittedDestinations?.length) {
                  <div class="cart_item_rail_permitted_stations">
                    <span>
                      Travel also permitted
                      {{ outwardPermittedOrigins?.length ? 'from' : 'to' }} stations near
                      {{
                        outwardPermittedOrigins?.length
                          ? detail.outwardDetail.departureStationName
                          : detail.outwardDetail.arrivalStationName
                      }}{{
                        outwardPermittedDestinations?.length && outwardPermittedOrigins?.length
                          ? ' and to stations near ' + detail.outwardDetail.arrivalStationName
                          : ''
                      }}.
                      <section class="container" (mouseleave)="tt5.close()">
                        <u
                          [ngbTooltip]="outwardPermittedStations"
                          #tt5="ngbTooltip"
                          triggers="manual"
                          (mouseenter)="tt5.open()"
                          (focus)="tt5.open()"
                          (blur)="tt5.close()"
                          tabindex="0"
                          i18n="@@ViewStations"
                          >View stations</u
                        >
                      </section></span
                    >
                  </div>
                }
                @if (detail.outbound?.ticketExtras; as ticketExtras) {
                  <div>
                    <div class="cart_item_rail_ticket_name">
                      <span i18n="@@itineraryRailTravelcard">Travelcard:</span>&nbsp;
                      @for (item of ticketExtras; track item; let last = $last) {
                        {{ item.location | translate }} ({{
                          item.date | date: 'EEEE dd MMMM YYYY'
                        }})
                        @if (!last) {
                          <span>,</span>
                        }
                      }
                    </div>
                  </div>
                }
                @if (detail?.outbound?.noFirstClassSeats) {
                  <div class="first-class-warning" id="outbound_first_class_warning">
                    <i
                      class="ico ico-exclamation-filled first-class-warning-icon"
                      aria-hidden="true"
                    ></i>
                    <span i18n="@@railNoFirstClassAllLegs"
                      >First Class accommodation is not available on all legs of this journey.</span
                    >
                  </div>
                }
              }
            </div>
          </div>
          <div class="rail_return_container"></div>
          <div [class.duplicate-item-wrapper]="duplicateBooking">
            @if (duplicateBooking && detail.inwardDetail) {
              <div class="duplicate-item-date">
                <i class="ico-rail"></i>&nbsp;
                @if (detail?.inwardDetail?.departureDateTime; as departureDateTime) {
                  <span i18n="@@basketPanelDepartureDateRail">Date:</span>
                  <strong
                    >{{ departureDateTime | sabsDate: 1 }}
                    @if (!detail.isEU) {
                      <span>{{ departureDateTime | sabsTimePipe: 'timeString' }}</span>
                    }
                    @if (detail.isEU) {
                      <span>{{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}</span>
                    }
                  </strong>
                }
              </div>
            }
            <div [class.duplicate-item-info]="duplicateBooking">
              @if (detail.inwardDetail; as inwardDetail) {
                <div class="cart_item_heading">
                  @if (!duplicateBooking) {
                    <i class="ico-rail"></i>&nbsp;
                  }
                  <strong
                    >{{ inwardDetail.departureStationName }} to
                    {{ inwardDetail.arrivalStationName }}</strong
                  >
                </div>
              }
              @if (detail?.inwardDetail?.departureDateTime; as departureDateTime) {
                <div class="cart_item_rail_ticket_times">
                  @if (!duplicateBooking) {
                    <span i18n="@@itineraryDepart">Depart:</span>
                    <span
                      >{{ departureDateTime | sabsDate: 1 }}
                      @if (!detail.isEU) {
                        {{ departureDateTime | sabsTimePipe: 'timeString' }}
                      }
                      @if (detail.isEU) {
                        {{ departureDateTime | sabsTimePipe: 'trainline_eu_time' }}
                      }
                    </span>
                    <br />
                    @if (detail?.inwardDetail?.arrivalDateTime; as arrivalDateTime) {
                      <span i18n="@@itineraryArrive">Arrives:</span>
                      <span
                        >{{ arrivalDateTime | sabsDate: 1 }}
                        @if (!detail.isEU) {
                          {{ arrivalDateTime | sabsTimePipe: 'timeString' }}
                        }
                        @if (detail.isEU) {
                          {{ arrivalDateTime | sabsTimePipe: 'trainline_eu_time' }}
                        }
                      </span>
                    }
                  }
                </div>
              }
              @if (detail?.inwardDetail?.supplierTickets[0]; as supplierTicket) {
                @if (supplierTicket?.legs; as legs) {
                  <div class="cart_item_operator">
                    <span i18n="@@flightBasketOperatedBy">Operated by:</span>
                    <span>{{ getRailOperators(legs) }}</span>
                  </div>
                }
                @if (supplierTicket?.ticketDescription; as ticketDescription) {
                  <div class="cart_item_rail_ticket_name">
                    <span i18n="@@basketPanelTicketRail">Ticket:</span>
                    @if (detail?.return?.isSplit) {
                      <app-split-ticket-icon></app-split-ticket-icon>
                    } @else {
                      <span
                        [ngClass]="detail?.return?.isSplit ? 'ticket-name-split' : 'ticket-name'"
                        >{{ ticketDescription }}</span
                      >
                    }

                    @if (!duplicateBooking) {
                      <a
                        tabindex="0"
                        (click)="
                          openTicketCondition(
                            detail?.return,
                            detail?.termsAndCond?.inboundTerms,
                            detail.inwardDetail.departureStationName,
                            detail.inwardDetail.arrivalStationName
                          )
                        "
                        (keydown.enter)="
                          openTicketCondition(
                            detail?.return,
                            detail?.termsAndCond?.inboundTerms,
                            detail.inwardDetail.departureStationName,
                            detail.inwardDetail.arrivalStationName
                          );
                          $event.stopPropagation()
                        "
                        role="button"
                        class="fare_rules_link"
                        attr.aria-label="Ticket conditions for {{
                          detail.inwardDetail.departureStationName
                        }} to {{ detail.inwardDetail.arrivalStationName }}"
                        ngbTooltip="Ticket conditions"
                        i18n-ngbTooltip
                        triggers="manual"
                        #ttReturnTicket="ngbTooltip"
                        (mouseenter)="ttReturnTicket.open()"
                        (focus)="ttReturnTicket.open()"
                        (blur)="ttReturnTicket.close()"
                        (mouseleave)="ttReturnTicket.close()"
                        ><i class="currency_info_icon"></i
                        ><span class="visuallyhidden" i18n="@@railBasketTicketConditions"
                          >Ticket conditions</span
                        ></a
                      >
                    }
                  </div>
                }
                @if (detail?.return?.isSplit && detail?.return?.fares?.length) {
                  <app-split-ticket-panel
                    [isSplit]="detail?.return?.isSplit"
                    [fares]="detail?.return?.fares"
                  >
                  </app-split-ticket-panel>
                }
                @if (detail?.return?.noFirstClassSeats) {
                  <div class="first-class-warning" id="inbound_first_class_warning">
                    <i
                      class="ico ico-exclamation-filled first-class-warning-icon"
                      aria-hidden="true"
                    ></i>
                    <span i18n="@@railNoFirstClassAllLegs"
                      >First Class accommodation is not available on all legs of this journey.</span
                    >
                  </div>
                }
                @if (inwardPermittedOrigins?.length || inwardPermittedDestinations?.length) {
                  <div class="cart_item_rail_permitted_stations">
                    <span>
                      Travel also permitted
                      {{ inwardPermittedOrigins?.length ? 'from' : 'to' }} stations near
                      {{
                        inwardPermittedOrigins?.length
                          ? detail.inwardDetail.departureStationName
                          : detail.inwardDetail.arrivalStationName
                      }}{{
                        inwardPermittedDestinations?.length && inwardPermittedOrigins?.length
                          ? ' and to stations near ' + detail.inwardDetail.arrivalStationName
                          : ''
                      }}.
                      <section class="container" (mouseleave)="tt6.close()">
                        <u
                          [ngbTooltip]="inwardPermittedStations"
                          #tt6="ngbTooltip"
                          triggers="manual"
                          (mouseenter)="tt6.open()"
                          (focus)="tt6.open()"
                          (blur)="tt6.close()"
                          tabindex="0"
                          i18n="@@ViewStations"
                          >View stations</u
                        >
                      </section>
                    </span>
                  </div>
                }
              }
            </div>
          </div>
        </div>
        @if (!duplicateBooking) {
          <div class="car_cart_item_to_point"></div>
        }
        @if (duplicateBooking) {
          <div class="cart_item_price">
            <strong i18n="@@basketPanelCostRail">Cost</strong>
            <strong>{{ rail.price | currency: rail.currency }}</strong>
          </div>
        }
      }
    }

    <ng-template #inwardPermittedStations>
      <div class="permitted_stations">
        @if (inwardPermittedOrigins?.length) {
          <div><strong i18n="@@Youcantravelfrom">You can travel from</strong>:</div>
        }
        @for (item of inwardPermittedOrigins; track item) {
          <div>{{ item }}</div>
        }
        @if (inwardPermittedDestinations?.length) {
          <div><strong i18n="@@Youcantravelto">You can travel to</strong>:</div>
        }
        @for (item of inwardPermittedDestinations; track item) {
          <div>{{ item }}</div>
        }
      </div>
    </ng-template>

    <ng-template #outwardPermittedStations>
      <div class="permitted_stations">
        @if (outwardPermittedOrigins?.length) {
          <div class=""><strong i18n="@@Youcantravelfrom">You can travel from</strong>:</div>
        }
        @for (item of outwardPermittedOrigins; track item) {
          <div>{{ item }}</div>
        }
        @if (outwardPermittedDestinations?.length) {
          <div><strong i18n="@@Youcantravelto">You can travel to</strong>:</div>
        }
        @for (item of outwardPermittedDestinations; track item) {
          <div>{{ item }}</div>
        }
      </div>
    </ng-template>

    <!-- TODO: handle OpenReturnJourney case -->
    <!-- TODO: handle DualSingleJourney case -->
  </div>
  @if (rail.detail.discountInfo?.length || rail?.searchQuery?.railCardQualifiers[0]?.code) {
    <div class="applied_discounts">
      <app-rail-cards
        [railCardQualifiers]="rail?.searchQuery?.railCardQualifiers"
        [trainlineRailcards]="rail.detail.discountInfo"
        [type]="serviceName"
        [basketItem]="rail"
      ></app-rail-cards>
    </div>
  }
  <!-- @if (!duplicateBooking) {
                                <app-rail-journey-details
                                [basketItem]="rail"></app-rail-journey-details>
                              } -->
  @if (!duplicateBooking) {
    @for (user of travellers; track user) {
      <div class="traveller-name">
        <b>{{ user.forename }}, {{ user.surname }}</b>
      </div>
    }
    <div class="cart_item_price">
      <strong>{{ rail.price | currency: rail.currency }}</strong>
      <em>
        <span i18n="@@basketPanelTotalPriceRail">&nbsp;Total Price</span>
        @if (numberTravellersText) {
          <span>{{ numberTravellersText }}</span>
        }
      </em>
    </div>
    @if (rail.detail.fullPrice > rail.price) {
      <div class="cart_item_full_price">
        <strong
          ><del>{{ rail.detail.fullPrice | currency: rail.currency }}</del></strong
        >
      </div>
    }
  }
</div>
